import { FormattedMessage } from 'react-intl'

const OPERATOR_TYPES = [
  {
    id: 'la_deals',
    title: <FormattedMessage id='liveaboard' defaultMessage='Liveaboard' />,
  },
  {
    id: 'dr_deals',
    title: <FormattedMessage id='dive_resort' defaultMessage='Dive resort' />,
  },
]

export { OPERATOR_TYPES }
